import React, { Component } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  Table,
  ButtonGroup,
  Card,
  Input
} from "reactstrap";
import Alert from "react-s-alert";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper} from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from ".";
import _ from "lodash";
const emptyEquipmentType = {
    name: ''
}
export default class EquipmentType extends Component {
  static displayName = EquipmentType.name;
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,
      equipmentTypeList: [],
      editEquipmentType: null
    };

    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.addEquipmentType = this.addEquipmentType.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    this.onChangeFilter({
      filterName: "activeOnly",
      value: true,
      filteredDisplay: "Active Only"
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/EquipmentTypes", payload)
      .then(response => {
        if (response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editEquipmentType: null
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters },
      () => { this.refreshList(null, null, filters, 1) }
    );
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  addEquipmentType() {
    this.setState({
      editEquipmentType: emptyEquipmentType
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editEquipmentType: { ...this.state.editEquipmentType, [fieldName]: e.target.value }
    })
  }

  onCancel() {
    this.setState({
      editEquipmentType: null
    });
  }

  onSave() {
    let type = Object.assign({}, this.state.editEquipmentType);
    if (type.name === "") {
      Alert.warning("Name is required.")
      return;
    }

    let payload = {
      Name: type.name
    }
    if (type.id) {
      payload.Id = type.id;
    }
    api.post("Admin/SaveEquipmentType", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${type.name} has been saved.`)
          this.refreshList();

        } else {
          Alert.error(response.data.message || "An error occurred.  The equipment type could not be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating equipment type."));
  }

  onEdit(typeId) {
    let list = this.state.pagedList.list.slice();
    let type = _.find(list, t => {
      return t.id === typeId
    })
    this.setState({
      editEquipmentType: type
    });
    window.scrollTo(0, 0);
  }


  onDelete(id) {
    if (!window.confirm(`Are you sure you'd like to delete this equipment type?`)) return;

    api.delete(`Admin/DeleteEquipmentType/${id}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Equipment type was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Equipment type cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the equipment type.")
      });
  }

  onRevive(id) {
    api.post("Admin/ReviveEquipmentType", id)
      .then(response => {
        if (response.data.success) {
          Alert.success("Equipment type was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Equipment type cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the equipment type."));
  }

  render() {
    const { editEquipmentType } = this.state;
    return (
      <div className="ml-4 mr-4">
        <Row className="p-2">
          <Col>
            <h5>Equipment Types</h5>
          </Col>
          <Col className="mr-3">
            <Button
              size="sm" color="success" className="float-right"
              onClick={this.addEquipmentType}
            >
              Add New Equipment Type
            </Button>
          </Col>
        </Row>

        {this.state.editEquipmentType ? (
          <Card className="p-2">
            <Row>
              <Col>Name: <Input type="text" maxLength="40" name="name" id="name" onChange={(e) => this.onInputChange(e, "name")} value={editEquipmentType.name} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing" onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editEquipmentType.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}


        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(e => (
                    <tr key={e.id}>
                      <td>{e.name}</td>
                      <td>
                        <ButtonGroup className="float-right">
                          {e.deactivatedAt ? (
                            <Button size="sm" className="cbdmdInfo" onClick={() => this.onRevive(e.id)}>Revive</Button>
                          ) : (
                              <React.Fragment>
                                <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={()=>this.onEdit(e.id)}>
                                  <FontAwesomeIcon
                                    icon={"edit"}
                                    className="ml-1 mt-0 mb-0 mr-1 pointer"
                                    title={"Edit Type"}
                                  />
                                </Button>
                                  <Button size="sm" color="danger" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(e.id)} title="Delete">
                                    <FontAwesomeIcon
                                      icon="trash-alt"
                                      className="ml-1 mt-0 mb-0 mr-1 pointer "
                                      title="Delete"
                                    />
                                  </Button>
                              </React.Fragment>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))) : null}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentType.js